import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { ImportStepIndicator } from "../../../components/dealer/InventoryImportShared";
import {
  IMPORT_MODES,
  PUBLISH_MODES,
} from "../../../constants/automapInventoryImportConstants";
import { fetchDealerPortalDealers } from "../../../services/automapDealerInventoryApi";
import {
  downloadInventoryImportTemplate,
  trackImportEvent,
  uploadAdminImport,
} from "../../../services/automapInventoryImportApi";

export default function AdminInventoryImportNewPage() {
  const navigate = useNavigate();
  const [dealers, setDealers] = useState([]);
  const [dealerId, setDealerId] = useState("");
  const [file, setFile] = useState(null);
  const [importMode, setImportMode] = useState("create_and_update");
  const [publishMode, setPublishMode] = useState("needs_review");
  const [confirmed, setConfirmed] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    trackImportEvent("inventory_import_page_viewed", { scope: "admin" });
    fetchDealerPortalDealers()
      .then((data) => setDealers(data.dealers || []))
      .catch(() => setDealers([]));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!dealerId) return setError("Selecciona un concesionario.");
    if (!file) return setError("Selecciona un archivo CSV.");
    if (!confirmed) return setError("Confirma el inventario del concesionario.");

    setUploading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("dealerId", dealerId);
      formData.append("importMode", importMode);
      formData.append("publishMode", publishMode);
      formData.append("inventoryConfirmed", "true");
      const result = await uploadAdminImport(formData);
      navigate(`/admin/inventory/imports/${result.import.id}`);
    } catch (err) {
      setError(err.message || "Error al subir.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Inventario"
        title="Nueva importación"
        description="Carga CSV de inventario en nombre de un concesionario."
      />
      <main className="admin-console__main wrap import-page">
        <ImportStepIndicator currentStep="upload" />

        <div className="import-instructions dealer-state-box">
          <button
            type="button"
            className="dealer-portal-btn"
            onClick={() => {
              downloadInventoryImportTemplate("admin");
              trackImportEvent("inventory_template_downloaded", { admin: true });
            }}
          >
            Descargar plantilla CSV
          </button>
        </div>

        <form className="import-upload-form dealer-state-box" onSubmit={handleSubmit}>
          <label>
            Concesionario
            <select value={dealerId} onChange={(e) => setDealerId(e.target.value)}>
              <option value="">Seleccionar…</option>
              {dealers.map((dealer) => (
                <option key={dealer.id} value={dealer.id}>
                  {dealer.businessName} · {dealer.city || "—"}
                </option>
              ))}
            </select>
          </label>

          <label>
            Archivo CSV
            <input type="file" accept=".csv,text/csv" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          </label>

          <label>
            Modo de importación
            <select value={importMode} onChange={(e) => setImportMode(e.target.value)}>
              {IMPORT_MODES.map((mode) => (
                <option key={mode.value} value={mode.value}>
                  {mode.label}
                </option>
              ))}
            </select>
          </label>

          <label>
            Modo de publicación
            <select value={publishMode} onChange={(e) => setPublishMode(e.target.value)}>
              {PUBLISH_MODES.map((mode) => (
                <option key={mode.value} value={mode.value}>
                  {mode.label}
                </option>
              ))}
            </select>
          </label>

          <label className="import-checkbox">
            <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} />
            Confirmo que esta información corresponde al inventario actual del concesionario.
          </label>

          {error ? <p className="import-error">{error}</p> : null}

          <div className="import-actions">
            <button type="submit" className="dealer-portal-btn primary" disabled={uploading}>
              {uploading ? "Procesando…" : "Continuar"}
            </button>
            <Link className="dealer-portal-btn" to="/admin/inventory/imports">
              Cancelar
            </Link>
          </div>
        </form>
      </main>
    </AdminPageLayout>
  );
}
